// <div data-controller="posts--show">
//
// </div>
import { Controller } from "@hotwired/stimulus";
import api from "@/utils/api";
import helpers from "@/utils/helpers";

export default class extends Controller {
  static targets = [ "scrollSpy", "writerTopBar" ];

  initialize() {
    this.popupDisplayed = false;
    this.prevScroll = window.scrollY || 0;
  }

  scrollTo(e) {
    const { scrollId } = e.target.dataset;
    this.scrollIntoView(scrollId);
    this.highlightSection(scrollId);
  }

  scrollIntoView(scrollId) {
    const scrollSection = document.getElementById(scrollId);
    if (scrollSection) {
      scrollSection.scrollIntoView({
        behavior: "auto",
        block: "center"
      })
    }
  }

  // 대상 헤더에 잠깐 은은한 강조를 준다. (각주 back-reference highlight 와 동일한 방식:
  // 클래스 제거 → 리플로우 강제 → 재부여 로 매번 애니메이션을 다시 시작시킨다.)
  highlightSection(scrollId) {
    const el = document.getElementById(scrollId);
    if (!el) return;
    el.classList.remove("header-spy-highlight");
    void el.offsetWidth; // 리플로우를 강제해 같은 항목을 다시 눌러도 애니메이션이 재생되게 함
    el.classList.add("header-spy-highlight");
  }

  // 해시(#섹션)로 진입한 경우, 대상 섹션을 화면 수직 중앙에 배치하고 그 자리에 "고정"한다.
  //
  // 예전에는 120ms 폴링으로 반복 재중앙정렬(scrollIntoView)했는데, 위쪽 lazy 이미지가
  // 로딩되며 레이아웃이 밀리면 그 사이 쌓인 이동량을 뒤늦게 한 번에 보정 → 화면이 아래로
  // 내려갔다 위로 튀는 흔들림이 보였다.
  //
  // 대신 scroll anchoring 방식을 쓴다: ResizeObserver 콜백은 레이아웃 변경 프레임의
  // paint "직전"에 실행되므로, 그 안에서 대상이 밀린 만큼(delta)을 스크롤로 함께 이동시키면
  // 밀린 프레임이 화면에 그려지기 전에 보정되어 대상이 화면상 제자리에 고정된다(점프가 안 보임).
  // - 사용자가 직접 스크롤(휠/터치/키)하면 고정을 멈춰 낚아채는 느낌을 방지한다.
  centerOnHashLanding(scrollId) {
    const el = document.getElementById(scrollId);
    if (!el) return;

    let cancelled = false;

    // 대상을 뷰포트 세로 중앙에 두는 데 필요한 목표 top(px).
    const desiredTop = () => Math.max(0, (window.innerHeight - el.offsetHeight) / 2);

    // 현재 화면상 위치와 목표의 차이만큼만 스크롤을 이동. (레이아웃이 밀려 대상이 내려가면
    // 그만큼 함께 내려가 화면상 위치를 유지 → 흔들림 없음)
    const anchor = () => {
      if (cancelled) return;
      const delta = el.getBoundingClientRect().top - desiredTop();
      if (Math.abs(delta) >= 1) window.scrollBy(0, delta);
    };

    const observed = el.closest("article") || document.body;
    const ro = new ResizeObserver(anchor);

    const stop = () => {
      if (cancelled) return;
      cancelled = true;
      ro.disconnect();
      ["wheel", "touchmove", "keydown"].forEach((evt) => window.removeEventListener(evt, stop));
    };
    ["wheel", "touchmove", "keydown"].forEach((evt) =>
      window.addEventListener(evt, stop, { passive: true, once: true })
    );

    // 브라우저 기본 해시 스크롤(상단 정렬)을 다음 프레임에 중앙 정렬로 덮어쓴 뒤 관찰 시작.
    requestAnimationFrame(() => {
      anchor();
      this.highlightSection(scrollId);
      if (!cancelled) ro.observe(observed);
    });
    // 모든 리소스 로딩이 끝나 레이아웃이 확정된 시점에 한 번 더 보정.
    if (document.readyState !== "complete") {
      window.addEventListener("load", () => requestAnimationFrame(anchor), { once: true });
    }

    // 사용자가 손대지 않아도 3초 뒤에는 고정을 종료(무한 관찰 방지).
    setTimeout(stop, 3000);
  }

  onScroll(e) {
    if (window.scrollY >= (document.body.offsetHeight * 0.5)) {
      if ((this.data.get("enable-popup") === "true") && (this.popupDisplayed === false)) {
        this.modalController.showModal();
        this.popupDisplayed = true;
      }
    }

    if (window.scrollY >= (200)) {
      const diff = this.prevScroll - window.scrollY;
      if (Math.abs(diff) < 20) {
        return
      }

      if (this.prevScroll <= window.scrollY) {
        this.writerTopBarTarget.classList.remove("sticky");
      } else {
        this.writerTopBarTarget.classList.add("sticky");
      }
      this.prevScroll = window.scrollY;
    }
  }

  get modalController() {
    return this.application.getControllerForElementAndIdentifier(document.getElementById("subscribeModal"), "components--subscribe-modal")
  }

  connect() {
    const anchor = window.location.hash.toString();
    if (anchor) {
      const elementId = decodeURIComponent(anchor.replace("#", ""));
      this.centerOnHashLanding(elementId)
    }
  }
}
